export function convertNumber(x, xMax, xMin, yMax, yMin, round) {
    let y = ((x - xMin) * (yMax - yMin)) / (xMax - xMin) + yMin;
    y = Math.round(y / round) * round;
    if (y > yMax)
        y = yMax;
    if (y < yMin)
        y = yMin;
    return y;
}
export function handleTransportError(log, error) {
    // The transports log their own errors, so we don't need to do it here.
    if (!('code' in error)) {
        log.error(`${error.message}\n${error.stack}`);
    }
}
